import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FadeView, LoadingDots, TextLink, theme } from '@sweetgreen/garnish';

import type { SweetpassMembershipLevelSectionProps } from '../hooks';

export const SwitchSubscriptionCta = (props: SwitchSubscriptionCtaProps) => {
  const { ctaSwitchSubscription, isSwitchSubscriptionCtaLoading = false } =
    props;

  if (!ctaSwitchSubscription) return null;

  return (
    <View style={styles.wrapper}>
      <FadeView show={!isSwitchSubscriptionCtaLoading}>
        <TextLink
          style={styles.contentCta}
          accessibilityLabel={ctaSwitchSubscription.accessibilityLabel}
          onPress={ctaSwitchSubscription.handler}
        >
          {ctaSwitchSubscription.title}
        </TextLink>
      </FadeView>

      <FadeView show={isSwitchSubscriptionCtaLoading}>
        <LoadingDots />
      </FadeView>
    </View>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type SwitchSubscriptionCtaProps = Readonly<{
  ctaSwitchSubscription: SweetpassMembershipLevelSectionProps['ctaSwitchSubscription'];
  isSwitchSubscriptionCtaLoading?: boolean;
}>;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
  },
  contentCta: {
    marginLeft: theme.spacing['2'],
  },
});
